import React from 'react';

import {
    ChargesType,
    CmsPageContentIdentifier,
    CmsPageContentType,
    TariffDisplayPrice
} from '@/types/av-check';
import {currencyParts, formatPrice, getCMSSnippetForDisplayPriceItemId, interpolate} from '@/utils';
import { Price } from '@/components/compendium';
import PriceCondAfter from "@/components/compendium/Price/PriceCondAfter";

export interface OfferPriceProps {
  charges: ChargesType,
  isAvCheckResultsDisplay?: boolean,
  technologyPricingLabels?: {DISCOUNT: string, SURCHARGE: string, MONTHLYLIST: string},
  chargesNature?:string,
  technologyPricingVariationHintLabel?: string,
  cms:CmsPageContentType,
  isDtagFtthTariff?: boolean,
  setShowPdpActivationCostInfo?: (showPdpActivationCostInfo:boolean)=>void,
  setShowPdpDevelopmentCostInfo?: (showPdpDevelopmentCostInfo:boolean)=>void,
  isGroupContainsXXLTariff?: boolean,
  displayPrice?: TariffDisplayPrice
}

const OfferPrice = ({
                        charges,isAvCheckResultsDisplay,
                        technologyPricingLabels,chargesNature
                        ,technologyPricingVariationHintLabel,
                        cms,
                        isDtagFtthTariff, setShowPdpActivationCostInfo, setShowPdpDevelopmentCostInfo,
                        isGroupContainsXXLTariff, displayPrice}: OfferPriceProps) => {
    let euros, cents,
        monthlyText;
    let nextCharges: string[] = [];
    let displayPriceList: string[] = [];
    if(displayPrice != undefined) {
        monthlyText= <span dangerouslySetInnerHTML={{ __html: cms[getCMSSnippetForDisplayPriceItemId(displayPrice.monthlyPrice.itemId)] }} />;
        [euros, cents] = currencyParts(displayPrice.monthlyPrice.value);
        nextCharges = displayPrice.nextPriceChargeDataList
            .map(({ recurringCosts, startingMonth }) =>  interpolate(cms[CmsPageContentIdentifier.monthlyPriceNext],
                {months: startingMonth, nextPrice:formatPrice(recurringCosts)} ));
        displayPriceList = displayPrice.priceCategoryWithRankDataList.map(priceCategoryWithRankData => {
            const text  = cms[getCMSSnippetForDisplayPriceItemId(priceCategoryWithRankData.itemId)];
            return text != undefined ? interpolate(cms[getCMSSnippetForDisplayPriceItemId(priceCategoryWithRankData.itemId)],
                {value: formatPrice(Math.abs(priceCategoryWithRankData.value)), maxValue: formatPrice(Math.abs(priceCategoryWithRankData.maxValue))}) : '';
        });
    } else {
        monthlyText="monatlich";
        [euros, cents] = currencyParts(chargesNature == "TECHNOLOGY_PRICING" ?
            charges.recurringDetails.BASE_CHARGE : charges.recurringCosts);

        if(!isGroupContainsXXLTariff){
            nextCharges = charges.nextPriceCharges
                .filter((nextPriceCharges) => nextPriceCharges.startingMonth !== 1)
                .map(({ recurringCosts, startingMonth }) =>  technologyPricingLabels? interpolate(technologyPricingLabels.MONTHLYLIST,
                    {months: startingMonth, nextPrice:formatPrice(recurringCosts)} ) : '');
        }
    }

  return (
    <Price
      cond={monthlyText}
      sum={euros}
      suffix={cents}
      condAfter={(
              <PriceCondAfter
                      nextCharges={nextCharges}
                      charges={charges}
                      isAvCheckResultsDisplay= {isAvCheckResultsDisplay}
                      chargesNature={displayPrice != undefined ? "" : chargesNature}
                      technologyPricingVariationHintLabel={technologyPricingVariationHintLabel}
                      cms={cms}
                      isDtagFtthTariff={isDtagFtthTariff}
                      setShowPdpActivationCostInfo={setShowPdpActivationCostInfo}
                      setShowPdpDevelopmentCostInfo={setShowPdpDevelopmentCostInfo}
                      displayPriceTextList ={displayPriceList}
            />
      )}
    />
  );
};

export default OfferPrice;
